
<template>
  <div class='week-manage atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <div class="params-wrap">
            <el-form-item class="flex-form-item" label="发布类型">
              <el-select clearable v-model="searchParam.Type" placeholder="发布类型">
                <el-option v-for="item in releaseType" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="工作分类">
              <common-select ref="workClassify" v-model="searchParam.WorkClassify" :list="workClassify" optLabel="itemDesc" optValue="itemValue" placeholder="工作分类" clearable></common-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="工作项目">
              <el-input v-model="searchParam.WorkItemContent" placeholder="工作项目" clearable></el-input>
            </el-form-item>
            <el-form-item class="flex-form-item" label="责任人">
              <selecter v-model="searchParam.ResWkNo"></selecter>
            </el-form-item>
          </div>
          <div class="btn-wrap">
            <el-form-item class="flex-form-item" label="创建时间">
              <el-date-picker v-model="searchParam.Start" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item class="flex-form-item" label="完成时间">
              <el-date-picker v-model="searchParam.Finish" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item class="flex-form-item" label="完成情况">
              <common-select ref="status" v-model="searchParam.CompleteStatus" :list="completeStatus" 
              optLabel="name" optValue="value" placeholder="完成情况"></common-select>
            </el-form-item>
            <el-form-item>
              <el-button size="min" type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="main-content-wrap">
        <div class="table-content-wrap" :style="{'width': currentShowRow ? 'calc(100% - 700px)' : ''}">
          <div class='table-content atb-flex atb-flex-column'>
            <vxe-table
              class='atb-table header-table edit-table'
              border='inner'
              height='100%'
              auto-resize
              resizable
              stripe
              highlight-hover-row
              highlight-current-row
              :data="monthtableData"
              @cell-click="expandRowDetail"
              ref="releasedMonthWork">
              <vxe-table-column type='seq' title="序号" width="55"></vxe-table-column>
              <vxe-table-column field="type" title="发布类型" width="110">
                <template #default="{row}">
                  <span v-if="row.type==='year'">年修订</span>
                  <span v-if="row.type==='month'">新增工作发布</span>
                  <span v-if="row.type==='todoWork'">工作待办</span>
                </template>
              </vxe-table-column>
              <!-- <vxe-table-column field="workItemCategory" min-width="100" title="类别">
                <template #default="{row}">
                  <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.workItemCategory}}
                  </div>
                </template>
              </vxe-table-column> -->
              <vxe-table-column field="workClassify" title="工作项分类" width="120">
                <template #default="{ row }">{{ workClassifyName(row) }}</template>
              </vxe-table-column>
              <vxe-table-column field="workItemContent" min-width="120" title="工作项目" >
                <template #default="{row}">
                  <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.workItemContent}}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column field="resWkName" title="指定人" width="120">
                <template #default="{row}">
                  <el-tooltip class='item' effect='dark' :disabled="row.resWks.length <= 1" :content='formatResWk(row)' popper-class="el-tooltip-400-200">
                    <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{formatResWk(row)}}</div>
                  </el-tooltip>
                </template>
              </vxe-table-column>
              <vxe-table-column field="wholeTarget" min-width="150" title="总目标" >
                <template #default="{row}">
                  <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.wholeTarget || row.fullTarget}}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column field="weight" title="权重" width="60"></vxe-table-column>
              <vxe-table-column field="isImportantWork" width="80" title="重点关注">
                <template #default="{row}">
                  <span v-if='row.isImportantWork == 0'>否</span>
                  <span v-if='row.isImportantWork == 1'>是</span>
                </template>
              </vxe-table-column>
              <vxe-table-column field="completeStatus" width="100" title="完成情况" show-overflow>
                <template #default="{ row }">
                  <div>
                    <el-tag v-if='row.completeStatus == 25 && row.type=="month"' type="complete" effect="dark">已完成</el-tag>
                    <el-tag v-if='row.completeStatus != 25 && row.type=="month"' type="complete" effect="dark">未完成</el-tag>
                    <el-tag v-if='row.completeStatus == 60 && row.type=="year"' type="complete" effect="dark">已完成</el-tag>
                    <el-tag v-if='row.completeStatus != 60 && row.type=="year"' type="complete" effect="dark">未完成</el-tag>
                    <el-tag v-if='row.completeStatus == 25 && row.type=="todoWork"' type="complete" effect="dark">已完成</el-tag>
                    <el-tag v-if='row.completeStatus != 25 && row.type=="todoWork"' type="complete" effect="dark">未完成</el-tag>
                    <!-- <el-tag v-if='row.completeStatus === 0' type="plan" effect="dark">计划</el-tag>
                    <el-tag v-if='row.completeStatus == 10' type="ongoing" effect="dark">进行中</el-tag>
                    <el-tag v-if='row.completeStatus == 20' type="complete" effect="dark">已完成</el-tag>
                    <el-tag v-if='row.completeStatus == 25' type="complete" effect="dark">总目标完成</el-tag>
                    <el-tag v-if='row.completeStatus == 30' type="delay" effect="dark">延迟</el-tag>
                    <el-tag v-if='row.completeStatus == 40' type="transfer" effect="dark">转移</el-tag>
                    <el-tag v-if='row.completeStatus == 50' type="close" effect="dark">暂停或关闭</el-tag> -->
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column field="creationTime" width="160" title="创建时间" >
                <template #default="{ row }">{{ row.creationTime? formatDate(new Date(row.creationTime), 'yyyy-MM-dd HH:mm:ss'): '' }}</template>
                </vxe-table-column>
              <vxe-table-column field="finishDate" width="100" title="完成时间" >
                <template #default="{ row }">{{ row.finishDate? formatDate(new Date(row.finishDate), 'yyyy-MM-dd'): '' }}</template>
                </vxe-table-column>
              <!-- <vxe-table-column field="" title="操作" fixed width='120' class-name='operation'>
                  <template #default="scope">
                    <el-button size="mini" type="primary" @click.stop='call(scope.row)'>提醒</el-button>
                  </template>
              </vxe-table-column> -->
              </vxe-table>
          </div>
          <div class='page-con atb-flex atb-flex-justify-end'>
            <vxe-pager
              background
              :current-page.sync="page.PageIndex"
              :page-size.sync="page.PageSize"
              :total="total"
              height="100%"
              pager-count="4"
              @page-change="handlePageChange"
              :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
            >
            </vxe-pager>
          </div>
        </div>
        <div v-if="currentShowRow" v-show="isCollapse" class="row-detail-wrap">
          <row-detail :rowData="currentShowRow" :monthWorkClassify="monthWorkClassify" :yearWorkClassify="yearWorkClassify" :yearCompleteList="yearCompleteList" />
        </div>
        <div v-if="currentShowRow" class="collapse" :style="{right: isCollapse ? '710px' : '20px'}" @click="collapseHandle()">
          <i :class="[isCollapse ? 'icon-shouqi' : 'icon-zhankai']"></i>
        </div>
      </div>
    </div>
    <common-dialog ref="detailDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :detailData="detailData"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  import _ from 'lodash';
  export default {
    components: {
      selecter:()=>import('@/component/global/customerSelect'),
      ReleaseDetail:()=>import('./ReleaseDetail'),
      rowDetail: () => import('./rowDetail.vue'),
    },
    name: "index",
    data() {
      return {
        searchParam: {
          Type: '',
          WorkClassify: '',
          WorkItemCategory: "",
          WorkItemContent: "",
          ResWkNo: "",
          Start: "",
          Finish: "",
          CompleteStatus:""
        },
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        monthtableData: [],
        companyList: [
          {value: '仪器', name: '仪器'},
          {value: '安图科技', name: '安图科技'}
        ],
        expandRowFlag: false,
        completeStatus:[
         {value: '0', name: '未完成'},
         {value: '1', name: '已完成'}
        ],
        releaseType: [
          {label: '年计划修订', value: 'year'},
          {label: '新增工作发布', value: 'month'},
          {label: '工作待办', value: 'todoWork'},
        ],
        defaultWorkClassify:[
          {
            itemValue: "0",
            itemDesc: "KPI工作",
          }
        ],
        categoryList: [],
        yearWorkClassify:[],
        monthWorkClassify:[],
        detailData: {},
        dialogContent: {},
        currentShowRow: null,
        isCollapse: false,
        yearCompleteList: [],
      }
    },
    computed: {
       workClassify(){
         if(this.searchParam.Type === "year"){
            return this.yearWorkClassify;
         } else if (this.searchParam.Type === "month" || this.searchParam.Type === "todoWork"){
            return this.monthWorkClassify;
         } else {
            return this.defaultWorkClassify;
          }
       }
    },
    created() {
      this.getWorkItemStatus();
    },
    mounted() {
      // this.getCategory();
      this.getYearWorkClassify().then(()=>{
        this.getMonthWorkClassify().then(()=>{
          this.getList(1);
        });      
      });
    },
    methods: {
      async getWorkItemStatus() {
        await this.$ajax.get(this.$api.common.getDict, {ItemType: 'YearWorkItemStatus'}).then((res) => {
          if (res.code === 0) {
            this.yearCompleteList = res.data && res.data.rows || [];
          }
        });
      },
      getCurrent(item) {
        this.currentTab = item.data.id;
      },
      getList(page) {
        this.currentShowRow = null;
        this.page.PageIndex=page;
        const params=_.cloneDeep(this.searchParam);
        if(params.Start&&params.Start.length>0){
           params.StartDateStart=this.formatDate(this.searchParam.Start[0],'yyyy-MM-dd HH:mm:ss');
           params.StartDateEnd=this.formatDate(this.searchParam.Start[1],'yyyy-MM-dd HH:mm:ss');
          delete params.Start;
        }
        if(params.Finish&&params.Finish.length>0){
           params.FinishDateStart=this.formatDate(this.searchParam.Finish[0],'yyyy-MM-dd HH:mm:ss');
           params.FinishDateEnd=this.formatDate(this.searchParam.Finish[1],'yyyy-MM-dd HH:mm:ss');
           delete params.Finish;
        }
       const pageParam= {SkipCount: (this.page.PageIndex - 1) * this.page.PageSize, MaxResultCount: this.page.PageSize} 
        let param = Object.assign({}, params, pageParam)
        this.$ajax.get(this.$api.add.released.allWorkList, param).then((res) => {
          if(res.code===0){
            this.monthtableData = [];
            const tableData = res.data.rows.details || [];
            tableData.forEach(item => {
              let row = {};
              if (item.items.length > 0) {
                row = item.items[0];
                let completeStatus = item.type === 'year' ? row.status : row.completeStatus;
                row.resWks = item.items.map(item2 => {
                  item2.type = item.type;
                  if (item.type === 'year' && item2.status != 60) {
                    completeStatus = item2.status;
                  } else if (item.type !== 'year' && item2.completeStatus != 25) {
                    completeStatus = item2.completeStatus;
                  }
                  return {
                    id: item2.id,
                    resWkName: item2.resWkName,
                    resWkNo: item2.resWkNo,
                    ...item2,
                  }
                })
                row.completeStatus = completeStatus;
                this.monthtableData.push(row);
              }
            })

            this.total = res.data&&res.data.total;
          }
        });
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      handlePageChange({currentPage}) {
        this.getList(currentPage);
      },
      exportExcel() {

      },

      async  getYearWorkClassify(){
        await this.$ajax.get(this.$api.common.getDict,{ItemType:'YearPlanWorkItemClassify'}).then((res)=>{
            if(res.code===0){
              this.yearWorkClassify = (res.data && res.data.rows || []).filter(t => !t.itemGroup);
            }
        });
      },
      async getMonthWorkClassify(){
        await this.$ajax.get(this.$api.common.getDict,{ItemType:'MonthWorkItemClassify'}).then((res)=>{
            if(res.code===0){
                this.monthWorkClassify=res.data&&res.data.rows||[];
            }
        });
      },
      getCategory() {
        this.$ajax.get(this.$api.Identity.Categord.categoryByNo, {userId: sessionStorage.getItem("LOGIN_NAME")}).then(res => {
          const item = res.data;
          this.categoryList = this.filterCategory(item);
        });
      },
      queryCategory(queryString, cb) {
         let categoryList = this.categoryList;
        // 调用 callback 返回建议列表的数据
        cb(categoryList);
      },
      workClassifyName(row){
          if(row.type==="month" || row.type === "todoWork"){
            return this.monthWorkClassify.length>0&&this.monthWorkClassify.find(t=>t.itemValue===row.workClassify.toString())&&this.monthWorkClassify.find(t=>t.itemValue===row.workClassify.toString()).itemDesc;
          }else{
            return this.yearWorkClassify.length>0&&this.yearWorkClassify.find(t=>t.itemValue===row.workClassify.toString())&&this.yearWorkClassify.find(t=>t.itemValue===row.workClassify.toString()).itemDesc;
        }
      },
      // showDetail(row) {
      //   if (row.type !== "month") return;
      //   this.dialogContent = {
      //     title: '新增工作详情',
      //     componentName: 'ReleaseDetail',
      //     width: '900px',
      //   };
      //   this.detailData.id = row.id;
      //   this.$refs.detailDialog.show();
      // },
      // eslint-disable-next-line no-unused-vars
      expandRowDetail({row, rowIndex, column}) {
        if (column.property === 'opera') return;
        this.isCollapse = true;
        this.monthtableData[rowIndex].expandRowFlag = !this.monthtableData[rowIndex].expandRowFlag;
        this.$refs.releasedMonthWork.updateData(this.monthtableData);
        if (row.type === 'todoWork') {
          this.currentShowRow = null;
          return;
        }
        if (row.resWks && row.resWks.length > 0) {
          this.currentShowRow = row;
        } else {
          this.currentShowRow = null;
        }
      },
      collapseHandle() {
        this.isCollapse = !this.isCollapse;
      },
      formatResWk(row) {
        return row.resWks.map(item => item.resWkName).join('，');
      },
      // call(row){
      //   this.$ajax.get(this.$api.add.released.monthPlanList, {id:row.id, type:1}).then((res) => {
      //     if(res.code===0){
      //        this.monthtableData = res.data&&res.data.rows.details;
      //       this.total = res.data&&res.data.total;
      //       this.$message.success('消息提醒成功');
      //     }
      //   });
      // }
    },
    watch: {
      "searchParam.Type":{
        handler(){
          this.$set(this.searchParam,'WorkClassify','')
        },
        immediate:true
      }
    }
  }
</script>
<style scoped lang='scss'>
  .week-manage {
    height: 100%;
    .atb-content-bg {
      margin-top: 0px;
      padding: 20px;
      flex: 1;
    }
    .page-con {
      flex: 0 0 56px;
    }
    .search {
      .atb-input{
        .params-wrap{
          display: flex;
          .flex-form-item{
            margin-bottom: 12px;
            display: flex;
            flex: 1;
          }
          .read-mode{
            align-self: flex-end;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete{
              width: 100%;
            }
          }
          .el-date-editor.el-input{
            width: 100%;
          }
        }
        .btn-wrap{
          .flex-form-item{
            margin-bottom: 12px;
              .el-form-item__content{
                .el-select{
               ::v-deep input{
                  flex: 1;
                  width: 125px;
                }
                
              }
            }
          }
          .read-mode{
            align-self: flex-end;
          }
          .el-date-editor{
            border-radius: 10px;
            width: 380px;
          }
        }
      }
    }
    .main-content-wrap {
      flex: 1;
      display: flex;
      overflow: hidden;
    }
    .table-content-wrap {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      max-width: 100%;
    }
    .row-detail-wrap {
      width: 700px;
      height: 100%;
      padding-left: 16px;
    }
    .collapse {
      margin-top: -15px;
      position: absolute;
      top: 50%;
      right: 710px;
      width: 15px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background-color: rgba(#000, 0.1);
      z-index: 99;
      cursor: pointer;
      &:hover {
        background-color: rgba(#000, 0.2);
      }
      i {
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }

</style>